<template>
  <div class="main">
    <header class="panel-heading">
      <h3 class="panel-title">宿舍資訊暨設備教育訓練專區</h3>
    </header>

    <section class="panel panel-default">
      <div class="panel-body">
        <div class="row form-group" v-if="isAdmin('stay')">
          <div class="col-md-12 text-right">
            <a href="javascript:;" class="btn btn-danger" @click="gotoView('stay.training.edit')">新增訓練模組</a>
          </div>
        </div>

        <div class="alert alert-info" v-if="!loading && modules.length === 0">
          目前尚未設定教育訓練模組。
        </div>

        <div class="text-center" v-if="loading">
          <i class="fa fa-spinner fa-spin"></i> 資料載入中...
        </div>

        <table v-if="!loading && modules.length > 0" class="table table-no-more table-bordered table-striped mb-none">
          <thead>
            <tr>
              <th class="text-center" width="22%">模組名稱</th>
              <th class="text-center" width="8%">上架</th>
              <th class="text-center" width="8%">題數</th>
              <th class="text-center" width="8%">總分</th>
              <th class="text-center" width="8%">及格分數</th>
              <th v-if="isAdmin('stay')" class="text-center" width="10%">作答次數</th>
              <th v-if="isAdmin('stay')" class="text-center" width="10%">通過人數</th>
              <th v-else class="text-center" width="12%">我的結果</th>
              <th class="text-center" :width="isAdmin('stay') ? '26%' : '24%'">操作</th>
            </tr>
          </thead>
          <tbody>
            <tr v-for="item in modules" :key="item.id">
              <td data-title="模組名稱">
                <div style="font-weight: bold;">{{ item.title }}</div>
                <div class="text-muted" v-if="item.description">{{ truncate(item.description) }}</div>
              </td>
              <td data-title="上架" class="text-center">{{ item.isPublished === 'Y' ? '是' : '否' }}</td>
              <td data-title="題數" class="text-center">{{ item.questionCount }}</td>
              <td data-title="總分" class="text-center">{{ item.totalScore }}</td>
              <td data-title="及格分數" class="text-center">{{ item.passScore }}</td>
              <td v-if="isAdmin('stay')" data-title="作答次數" class="text-center">{{ item.attemptCount }}</td>
              <td v-if="isAdmin('stay')" data-title="通過人數" class="text-center">{{ item.passCount }}</td>
              <td v-else data-title="我的結果" class="text-center">
                <span :class="resultClass(item.latestResult)">{{ resultLabel(item.latestResult) }}</span>
              </td>
              <td data-title="操作" class="text-center">
                <template v-if="isAdmin('stay')">
                  <a href="javascript:;" class="btn-link" @click="gotoView('stay.training.edit', { id: item.id })">編輯</a>
                  <span class="action-separator">|</span>
                  <a href="javascript:;" class="btn-link" @click="openResultModal(item)">結果</a>
                  <span class="action-separator">|</span>
                  <a href="javascript:;" class="btn-link text-danger" @click="deleteModule(item)">刪除</a>
                </template>
                <template v-else>
                  <a href="javascript:;" class="btn btn-primary btn-sm" @click="gotoView('stay.training.quiz', { id: item.id })">
                    {{ item.latestResult && item.latestResult.passed === 'Y' ? '重新作答' : '開始作答' }}
                  </a>
                </template>
              </td>
            </tr>
          </tbody>
        </table>
      </div>
    </section>

    <div class="modal fade" id="trainingResultModal" tabindex="-1" role="dialog">
      <div class="modal-dialog modal-lg" role="document">
        <div class="modal-content">
          <div class="modal-header">
            <button type="button" class="close" data-dismiss="modal"><span>&times;</span></button>
            <h4 class="modal-title">{{ resultModal.title || '作答結果' }}</h4>
          </div>
          <div class="modal-body">
            <div class="row form-group" v-if="resultModal.summary">
              <div class="col-md-4">作答次數：{{ resultModal.summary.attemptCount }}</div>
              <div class="col-md-4">學生人數：{{ resultModal.summary.studentCount }}</div>
              <div class="col-md-4">通過人數：{{ resultModal.summary.passedStudentCount }}</div>
            </div>
            <div class="alert alert-info" v-if="!resultModal.loading && resultModal.rows.length === 0">目前尚無作答紀錄。</div>
            <div class="text-center" v-if="resultModal.loading">
              <i class="fa fa-spinner fa-spin"></i> 結果載入中...
            </div>
            <table class="table table-bordered table-striped" v-if="!resultModal.loading && resultModal.rows.length > 0">
              <thead>
                <tr>
                  <th class="text-center">學號</th>
                  <th class="text-center">姓名</th>
                  <th class="text-center">最近作答次數</th>
                  <th class="text-center">分數</th>
                  <th class="text-center">是否通過</th>
                  <th class="text-center">送出時間</th>
                </tr>
              </thead>
              <tbody>
                <tr v-for="row in resultModal.rows" :key="row.id">
                  <td class="text-center">{{ row.account }}</td>
                  <td class="text-center">{{ row.studentName }}</td>
                  <td class="text-center">{{ row.attemptNo }}</td>
                  <td class="text-center">{{ row.score }}</td>
                  <td class="text-center">{{ row.passed === 'Y' ? '是' : '否' }}</td>
                  <td class="text-center">{{ row.submittedDate ? customFormatter(row.submittedDate, 'YYYY/MM/DD HH:mm') : '' }}</td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  data() {
    return {
      loading: false,
      modules: [],
      resultModal: {
        title: "",
        loading: false,
        summary: null,
        rows: []
      }
    };
  },
  mounted() {
    this.loadModules();
  },
  methods: {
    loadModules() {
      this.loading = true;
      this.$axios.get('/api/DormitoryTraining/modules').then(resp => {
        if (resp.data.status === 'success') {
          this.modules = resp.data.data || [];
        } else {
          bootbox.alert(resp.data.msg || '載入失敗');
        }
      }).finally(() => {
        this.loading = false;
      });
    },
    truncate(value) {
      if (!value) {
        return '';
      }
      return value.length > 60 ? `${value.substring(0, 60)}...` : value;
    },
    resultLabel(result) {
      if (!result) {
        return '尚未作答';
      }
      return result.passed === 'Y' ? `已通過 (${result.score} 分)` : `未通過 (${result.score} 分)`;
    },
    resultClass(result) {
      if (!result) {
        return 'label label-default';
      }
      return result.passed === 'Y' ? 'label label-success' : 'label label-danger';
    },
    openResultModal(item) {
      this.resultModal.title = item.title;
      this.resultModal.rows = [];
      this.resultModal.summary = null;
      this.resultModal.loading = true;
      $('#trainingResultModal').modal('show');
      this.$axios.get(`/api/DormitoryTraining/module/${item.id}/results`).then(resp => {
        if (resp.data.status === 'success') {
          this.resultModal.summary = resp.data.data;
          this.resultModal.rows = resp.data.data.rows || [];
        } else {
          bootbox.alert(resp.data.msg || '載入結果失敗');
        }
      }).finally(() => {
        this.resultModal.loading = false;
      });
    },
    deleteModule(item) {
      bootbox.confirm(`是否刪除「${item.title}」？`, result => {
        if (!result) {
          return;
        }
        this.$axios.delete(`/api/DormitoryTraining/module/${item.id}`).then(resp => {
          if (resp.data.status === 'success') {
            this.loadModules();
          } else {
            bootbox.alert(resp.data.msg || '刪除失敗');
          }
        });
      });
    }
  }
};
</script>

<style scoped>
.action-separator {
  margin: 0 6px;
  color: #999;
}
</style>